import { render, staticRenderFns } from "./departmentDetail.vue?vue&type=template&id=2472d846&"
import script from "./departmentDetail.vue?vue&type=script&lang=js&"
export * from "./departmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./departmentDetail.vue?vue&type=style&index=0&id=2472d846&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports